import {TFunction} from "i18next";
import {object, ObjectSchema, string} from "yup";
import {fieldDefinedError} from "../rest/validation";
import i18n from "i18next";
import {Locale} from "./i18n";

export interface TranslatedValue {
  language: string,
  translation: string
}

export function translatedValueSchema(t: TFunction): ObjectSchema<TranslatedValue> {
  return object({
    language: string().defined(fieldDefinedError(t)),
    translation: string().defined(fieldDefinedError(t))
  })
}

/**
 * Returns the TranslatedValue translation from the list that is for the actual langauge used inside i18n (or the fallback language when configured)
 */
export function getTranslatedValue(translatedValues: TranslatedValue[]) {
  if (!translatedValues || translatedValues.length === 0) {
    return undefined
  }
  const forLang = translatedValues.find(translatedValue => translatedValue.language === i18n.language)
  if (!forLang) {
    // Fallback: We just return the first entry if we cannot find our language
    return translatedValues.find(translatedValue => translatedValue.language === Locale.en)?.translation;
  }
  return forLang?.translation;
}
